import { render, staticRenderFns } from "./ModuleReporter.vue?vue&type=template&id=4b9ad50c&scoped=true"
import script from "./ModuleReporter.vue?vue&type=script&lang=js"
export * from "./ModuleReporter.vue?vue&type=script&lang=js"
import style0 from "./ModuleReporter.vue?vue&type=style&index=0&id=4b9ad50c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9ad50c",
  null
  
)

export default component.exports